var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNonPerformingAsssetsToTotalAssets = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00126 10.4361C2.72526 10.4361 2.45076 10.3171 2.25426 10.0855C1.88676 9.65506 1.92426 8.99455 2.33676 8.61265L6.83676 4.43832C7.05126 4.23954 7.33626 4.14563 7.62126 4.18319L15.4048 5.16769L19.8133 0.808666C20.2153 0.414241 20.8483 0.429892 21.2263 0.849361C21.6058 1.26726 21.5893 1.92777 21.1888 2.32376L16.4383 7.0193C16.2223 7.23216 15.9253 7.3339 15.6313 7.2979L7.82826 6.31027L3.66576 10.1716C3.47526 10.3484 3.23826 10.4361 3.00126 10.4361Z",
    fill: "#6C7DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.252 5.21831C21.057 5.21831 20.865 5.13848 20.721 4.98979L17.2215 1.33666C17.007 1.11284 16.9425 0.776329 17.058 0.48364C17.1735 0.190952 17.448 0 17.751 0H21.2505C21.6645 0 22.0005 0.3506 22.0005 0.78259V4.43415C22.0005 4.75032 21.8175 5.03518 21.537 5.15727C21.4455 5.19796 21.348 5.21831 21.252 5.21831Z",
    fill: "#6C7DE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99945 17.9991V20.8681H0.999451V17.9991C0.999451 17.2791 1.55895 16.6953 2.24895 16.6953H5.74845C6.43845 16.6953 6.99945 17.2791 6.99945 17.9991Z",
    fill: "#00D2A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 11.7393V20.869H9.00012V11.7393C9.00012 11.0194 9.55962 10.4355 10.2496 10.4355H13.7491C14.4406 10.4355 15.0001 11.0194 15.0001 11.7393Z",
    fill: "#00D2A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9972 13.8272V20.8705H16.9972V13.8272C16.9972 13.1073 17.5567 12.5234 18.2467 12.5234H21.7477C22.4377 12.5219 22.9972 13.1073 22.9972 13.8272Z",
    fill: "#00D2A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2507 23.9988H0.750671C0.336671 23.9988 0.000671387 23.6482 0.000671387 23.2162C0.000671387 22.7842 0.336671 22.4336 0.750671 22.4336H23.2507C23.6647 22.4336 24.0007 22.7842 24.0007 23.2162C24.0007 23.6482 23.6647 23.9988 23.2507 23.9988Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNonPerformingAsssetsToTotalAssets);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/non_performing_asssets_to_total_assets.542b3c438e01f58b34b87c0fec348fe8.svg";